<template>
    <form class="form-wrapper"
          autocomplete="off"
          @submit.prevent="submit"
    >
        <div class="form-wrapper-body m-0">
            <div class="ActivityAftercareDropInModal">
                <h3 class="ActivityAftercareDropInModal-title">{{activity.aftercareName}}</h3>
                <p class="ActivityAftercareDropInModal-description">Drop-in</p>

                <template v-if="(children && children.length) || (options && options.isSchool)">
                    <div class="mt-3 mb-2">
                        <p class="ActivityAftercareDropInModal-label">Select child</p>
                        <select-box :required="true"
                                    :data-list="children || []"
                                    :disabled="options && options.isSchool"
                                    :format-callback="child => `${child.firstName} ${child.lastName}`"
                                    @selected="onChildSelect"
                        />
                    </div>

                    <template v-if="form.childId && this.activitiesAftercareDropInFull && disabledDates">
                        <div class="my-2">
                            <p class="ActivityAftercareDropInModal-label">Select Dates</p>
                            <date-picker id="dates"
                                         :required="true"
                                         :multiple-select="true"
                                         :date-start="activity.aftercareStartDate"
                                         :date-end="activity.aftercareEndDate"
                                         :disabled-dates="disabledDates"
                                         :active-days="activeDays"
                                         v-model="form.dates"
                                         >
                            </date-picker>
                        </div>
                    </template>

                    <!--<template v-if="activityExtrasAftercareUses && activityExtrasAftercareUses.length">
                        <div class="my-2">
                            <p class="ActivityAftercareDropInModal-label">Selected Add-ons</p>
                            <div class="d-flex flex-wrap">
                                <chip v-for="addOn in activityExtrasAftercareUses"
                                      :key="addOn.id"
                                      class="mx-1 my-1"
                                      :style="{ backgroundColor:'#b496fa', color:'#ffffff'}"
                                      :required-chip=true
                                      :label="addOn.name"
                                      :width="140">
                                </chip>
                            </div>
                        </div>
                    </template>-->

                    <template v-if="activityAddOnsList && activityAddOnsList.length && !isNewPaymentFlow">
                        <div class="my-2">
                            <p class="ActivityAftercareDropInModal-label">Select activity extras</p>
                            <select-box :required="false"
                                        :multiple-select="true"
                                        :default-value="defaultValueAddOn"
                                        :data-list="activityAddOnsList"
                                        :format-callback="addOn => addOn.name"
                                        @selected="onActivityExtrasSelect"
                            />
                        </div>
                    </template>

                    <template v-if="(teachers && teachers.length && activitiesAftercareRequired && activitiesAftercareRequired.teacher)
                                 || (options && options.isSchool && activitiesAftercareRequired && activitiesAftercareRequired.teacher)">
                        <div class="my-2">
                            <p class="ActivityAftercareDropInModal-label">Who is your teacher</p>
                            <select-box :data-list="teachers || []"
                                        :disabled="options && options.isSchool"
                                        :required="activitiesAftercareRequired && activitiesAftercareRequired.teacherRequired"
                                        :format-callback="teacher => teacher.name"
                                        @selected="onTeacherSelect"
                            />
                        </div>
                    </template>

                    <template v-if="(pickUps && pickUps.length && activitiesAftercareRequired && activitiesAftercareRequired.pickUpOptions)
                                 || (options && options.isSchool && activitiesAftercareRequired && activitiesAftercareRequired.pickUpOptions)">
                        <div class="my-2">
                            <p class="ActivityAftercareDropInModal-label">Pickup Options</p>
                            <select-box :data-list="pickUps || []"
                                        :disabled="options && options.isSchool"
                                        :required="activitiesAftercareRequired && activitiesAftercareRequired.pickUpOptionsRequired"
                                        :format-callback="pickUp => pickUp.name"
                                        @selected="onPickUpSelect"
                            />
                        </div>
                    </template>

                    <template v-if="tShirtSizes && tShirtSizes.length && activitiesAftercareRequired && activitiesAftercareRequired.tshirt">
                        <div class="mb-3">
                            <p class="ActivityAftercareDropInModal-label">T-Shirt size</p>
                            <div class="d-flex align-items-center w-100 mb-4">
                                <p class="w-25 text-gray mb-0">Young</p>
                                <div class="ActivityAftercareDropInModal-checkboxes w-75">
                                    <div v-for="sizeYoung of sizesYoung"
                                         :key="sizeYoung.id">
                                        <label :class="['ActivityAftercareDropInModal-checkboxes-checkbox', { 'disabled': !sizeYoung.status }]">
                                            <input type="radio"
                                                   name="tShirt"
                                                   :id="sizeYoung.id"
                                                   :value="sizeYoung.id"
                                                   :checked="sizeYoung.id == form.tshirtSizeId"
                                                   :disabled="!sizeYoung.status"
                                                   @change="form.tshirtSizeId = $event.target.value"
                                            />
                                            <span>{{ sizeYoung.size.substring(1) }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center w-100">
                                <p class="w-25 text-gray mb-0">Adult</p>
                                <div class="ActivityAftercareDropInModal-checkboxes w-75">
                                    <div v-for="sizeAdult of sizesAdult"
                                         :key="sizeAdult.id">
                                        <label :class="['ActivityAftercareDropInModal-checkboxes-checkbox', { 'disabled': !sizeAdult.status }]">
                                            <input type="radio"
                                                   name="tShirt"
                                                   :id="sizeAdult.id"
                                                   :value="sizeAdult.id"
                                                   :checked="sizeAdult.id == form.tshirtSizeId"
                                                   :disabled="!sizeAdult.status"
                                                   @change="form.tshirtSizeId = $event.target.value"
                                            />
                                            <span> {{ sizeAdult.size}}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="error mt-3">{{ errors.first('tShirt') }}</div>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div class="not-found m-0 text-center"
                         :style="{'height': '85%'} "
                    >
                        <img src="../../assets/img/background.png"
                             :style="{ 'width': '280px', 'height': '200px', 'margin-bottom': '25px'}"
                        >
                        Oh no! First add child, please.
                    </div>
                </template>
            </div>
        </div>

        <div class="form-wrapper-footer d-flex justify-content-between"
            :key="formsButtonUpdate">
            <div v-if="activity.dropInPrice === 0"
                 class="ActivityAftercareDropInModalBottom text-green"
            >
                FREE
            </div>
            <div v-else
                 class="d-flex flex-column"
            >
                <span v-if="options && options.isSchool" class="ActivityAftercareDropInModalBottom">{{activity.dropInPrice.toFixed(2)}}</span>
                <span v-else class="ActivityAftercareDropInModalBottom"> {{schoolInfo.currency | currencySign}} {{activity.dropInPrice.toFixed(2)}}</span>
                <span :style="{ color: '#0d0d25' }"> {{activity.dropInBillingRate | toCapitalize}} </span>
            </div>

            <button :class="['form-wrapper-footer-button', 'primary-btn', isLoading && 'ie-spinner']"
                    :style="{'width':'150px'}"
                    :disabled="!form.dates.length || disabledButton"
                    type="submit"
                    v-spinner="isLoading"
                    v-if="activityForms.length === 0"
            >
                {{ !isNewPaymentFlow ? 'Add to Cart' : 'Pay Now' }}
            </button>
            <button 
                v-else
                :class="[
                    'primary-btn',
                ]"
                :style="{ width: '150px' }"
                :disabled="!form.dates.length || disabledButton"
                v-spinner="isLoading"
                @click.prevent="goToCustomForms"
                >
                Continue
            </button>
        </div>
    </form>
</template>

<script>
    import * as _ from 'lodash';
    import { mapActions, mapGetters, mapMutations } from 'vuex';
    import * as types from '@/store/mutationTypes';
    import { FormMixin } from '@/mixins/FormMixin';
    import { GetUserInfoFromLocalStorage } from '@/mixins/GetUserInfoFromLocalStorage';
    import { eventBus } from '@/main';

    const CustomFormModal = () => import(/* webpackChunkName: "activities" */ '@/components/modals/CustomFormModal');

    export default {
        name: 'ActivityAftercareDropInModal',

        components: {
            Chip:       () => import('@/components/controls/Chip'),
            SelectBox:  () => import('@/components/controls/SelectBox'),
            DatePicker: () => import('@/components/controls/DatePicker'),
            CustomForm: () => import('@/components/modals/CustomForm/CustomForm.vue')
        },

        data() {
            return {
                sizesAdult: [],
                sizesYoung: [],
                form: {
                    childId: null,
                    dates: [],
                    addOnIds: [],
                    //usedAddOnIds: [],
                    teacherId: null,
                    pickUpOptionId: null,
                    tshirtSizeId: null
                },
                formsButtonUpdate: 0
            }
        },

        computed: {
            ...mapGetters([
                'isLoading',
                'schoolInfo',
                'children',
                'teachers',
                'pickUps',
                'tShirtSizes',
                'activity',
                'activityExtrasAftercare',
                'activityExtrasAftercareUses',
                'activitiesAftercareRequired',
                'activitiesAftercareDropInFull',
                'options',
                'customForms',
                'activityForms'
            ]),

            //not allow select past date for dropins
            // aftercareDropinStartDate() {
            //     // aftercareStartDate: "2024-10-17" If aftercareStartDate is before today, then set today as start date
            //     return this.activity.aftercareStartDate < new Date().toISOString().split('T')[0]
            //         ? new Date().toISOString().split('T')[0]
            //         : this.activity.aftercareStartDate;
            // },

            disabledButton() {
                return !this.formValid || this.formPristine || this.isLoading || (this.activitiesAftercareRequired && this.activitiesAftercareRequired.tshirtRequired && !this.form.tshirtSizeId) || (this.options && this.options.isSchool);
            },

            activityAddOnsList() {
                if(this.activityExtrasAftercareUses && this.activityExtrasAftercareUses.length) {
                    this.activityExtrasAftercare && this.activityExtrasAftercareUses.forEach(item =>
                        this.activityExtrasAftercare.forEach((el, index) =>
                            el.id === item.id && this.activityExtrasAftercare.splice(index, 1)
                        ));

                    return this.activityExtrasAftercare
                } else {
                    return this.activityExtrasAftercare
                }
            },

            defaultValueAddOn() {
                return this.activityAddOnsList.filter(addOn => addOn.required);
            },

            activeDays() {
                let activityDays = [];
                this.activity && this.activity.days && this.activity.days.length && this.activity.days.forEach(item => item.dropIn && activityDays.push(item.day));

                return activityDays;
            },

            disabledDates() {
                return [...new Set([...this.activitiesAftercareDropInFull, ... this.activity.noSessionDates])];
            },

            isNewPaymentFlow() {
                return this.schoolInfo && this.schoolInfo.schoolFeatures && this.schoolInfo.schoolFeatures['new-payments'];
            },
        },

        mixins: [GetUserInfoFromLocalStorage, FormMixin],

        methods: {
            ...mapActions([
                'showSpinner',
                'closeModal',
                'getChildren',
                'getTeachers',
                'getTShirtSizes',
                'getPickUpOptions',
                'getActivityExtrasAftercare',
                'getActivityExtrasAftercareWhichUsesBefore',
                'getAftercareRequired',
                'getFullDropInDates',
                'addToCartAftercare',
                'openModal',
                'sendCustomForms',
                'getNotFilledCustomForms',
                'checkChildBeforeAftercareEnroll'
            ]),

            ...mapMutations({
                setActivityExtras: types.SET_ACTIVITY_EXTRAS_AFTERCARE,
                setActivityExtrasWhichUsesBefore: types.SET_ACTIVITY_CHILD_ROSTER_INFO,
                setActivityRequired: types.SET_ACTIVITIES_AFTERCARE_REQUIRED,
                setActivityAftercareDropInFull: types.SET_ACTIVITIES_AFTERCARE_DROP_IN_FULL,
                cleanCustomForms: types.CLEAN_CUSTOM_FORM,
                cleanActivityForms: types.CLEAN_ACTIVITY_FORMS
            }),

            async onChildSelect(child) {
                this.form.dates = [];
                this.setActivityExtras(null);
                this.setActivityAftercareDropInFull(null);
                if (child) {
                    this.$emit('removeModal', 'CustomFormModal');
                    this.cleanCustomForms();
                    this.form.childId = child.id;
                    if (this.activity.forms.length !== 0) {
                        await this.getNotFilledCustomForms({
                            activityType: 'Aftercare',
                            activityId: this.activity.id,
                            formIds: this.activity.forms.map(el => el.id),
                            childId: child.id
                        });
                        this.formsButtonUpdate += 1;
                    }
                    await Promise.all([
                        this.getFullDropInDates({ aftercareId: this.activity.id, childId: child.id }),
                        this.getActivityExtrasAftercare(this.activity.id),
                       /* this.getActivityExtrasAftercareWhichUsesBefore({ aftercareId: this.activity.id, childId: child.id })
                            .then(() => {
                                this.form.usedAddOnIds = [];
                                this.activityExtrasAftercareUses && this.activityExtrasAftercareUses.forEach(item => this.form.usedAddOnIds.push(item.id));

                                return this.form.usedAddOnIds
                            })*/
                    ])
                }
            },

            onTeacherSelect(teacher) {
                if (teacher) {
                    this.form.teacherId = teacher.id;
                } else {
                    this.form.teacherId = '';
                }
            },

            onPickUpSelect(pickUp) {
                if (pickUp) {
                    this.form.pickUpOptionId = pickUp.id;
                } else {
                    this.form.pickUpOptionId = '';
                }
            },

            onActivityExtrasSelect(addOns) {
                if (addOns) {
                    addOns.length
                        ? this.form.addOnIds = addOns.map(addOn => addOn.id)
                        : this.form.addOnIds = [];
                }
            },

            setSizes() {
                _.forEach(this.tShirtSizes, obj => {
                    obj.size.search('Y')
                        ? this.sizesAdult.push(obj)
                        : this.sizesYoung.push(obj)
                });
            },

            async goToCustomForms() {
                try {
                    this.showSpinner(true);
                    await this.checkChildBeforeAftercareEnroll({
                        aftercareId: this.activity.id, 
                        childId: this.form.childId,
                        aftercareDayId: this.form.dates
                    });
                } finally {
                    this.showSpinner(false);
                }
                if (this.activityForms.length) {
                    this.openModal({
                    modal: CustomFormModal,
                    options: {
                        customForms: this.activityForms,
                        modalType: 3,
                        childId: this.form.childId,
                        activityId: this.activity.id,
                        activityType: 'Aftercare',
                        activityStatus: this.activity.dropInStatus
                    }
                    });
                }
            },

            async submit() {
                const valid = await this.$validator.validateAll();

                if (!valid) return;

                try {
                    this.showSpinner(true);

                    // if custom form was added
                    if(this.activityForms.length) {
                        await this.sendCustomForms({
                            forms: this.customForms,
                            parentId: this.UserInfo.userId
                        });
                    }
                    //----

                    await this.addToCartAftercare({
                        form: {
                            ...this.form,
                            aftercareId: this.activity.id
                        },
                        aftercareId: this.activity.id,
                        enrollTo: 'Drop-in'
                    });
                    this.closeModal();
                } finally {
                    this.showSpinner(false);
                }
            }
        },

        async beforeMount() {
            eventBus.$on('submitCustomForms', this.submit);
            this.getAftercareRequired(this.activity.id);
            (this.options && !this.options.isSchool) && this.getChildren(this.UserInfo.userId);
            await this.getTShirtSizes();
            (this.options && !this.options.isSchool) && this.getPickUpOptions();
            (this.options && !this.options.isSchool) && this.getTeachers();
            this.setSizes();
        },

        beforeDestroy() {
            eventBus.$off('submitCustomForms', this.submit);
            this.setActivityExtras(null);
            //this.setActivityExtrasWhichUsesBefore(null);
            this.setActivityAftercareDropInFull(null);
            this.setActivityRequired(null);
            this.cleanCustomForms();
            this.cleanActivityForms();
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/styles/variables/colors';

    .ActivityAftercareDropInModal {
        height: 100%;
        margin: 0 30px;

        &-title {
            margin-bottom: 12px;
            text-align: left;
            word-break: break-word;
            font-size: 28px;
            font-weight: 700;
            color: $Dark;
            @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) { //for IE
                word-break: break-all;
            }
        }

        &-description {
            font-size: 16px;
            color: $Copyright;
            word-break: break-word;
            font-weight: 700;
            @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) { //for IE
                word-break: break-all;
            }
        }

        &-label {
            margin-bottom: 10px;
            font-size: 14px;
            font-weight: 700;
        }

        &-checkboxes {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            &-checkbox {
                position: relative;
                width: 35px;
                height: 35px;
                margin: 5px 0;
                border-radius: 2px;
                cursor: pointer;
                background-color: $ComplementaryBgTxtDarker;

                input {
                    position: absolute;
                    height: 0;
                    width: 0;
                    display: none;
                    cursor: pointer;

                    &:checked ~ span {
                        border-radius: 2px;
                        color: $White;
                        background-color: $Violet;
                    }
                }

                span {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 35px;
                    height: 35px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 11px;
                    font-weight: 500;
                    color: $Dark;
                }
            }

            .disabled {
                opacity: 0.4;
                cursor: no-drop;
            }
        }
    }

    .ActivityAftercareDropInModalBottom {
        font-size: 24px;
        font-weight: 700;
        color: $SoftBlue;
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/ActivityAftercareDropInModal.vue